import { render } from "./create-store.vue?vue&type=template&id=4dbf0e90&scoped=true"
import script from "./create-store.vue?vue&type=script&lang=js"
export * from "./create-store.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./create-store.vue?vue&type=style&index=1&id=4dbf0e90&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dbf0e90"]])

export default __exports__